import { render } from "./TravelIcon.vue?vue&type=template&id=b51918aa&scoped=true"
import script from "./TravelIcon.vue?vue&type=script&lang=js"
export * from "./TravelIcon.vue?vue&type=script&lang=js"

import "./TravelIcon.vue?vue&type=style&index=0&id=b51918aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51918aa"]])

export default __exports__